var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "container" }, [
      _c("img", {
        attrs: { src: "/images/web/nodata.png", alt: "页面不存在" }
      }),
      _c("h1", { staticClass: "error-msg" }, [
        _vm._v("很抱歉，您要访问的页面不存在！")
      ]),
      _c("p", { staticClass: "desc" }, [_vm._v("可能原因：")]),
      _c("div", [
        _c("p", { staticClass: "desc" }, [
          _vm._v("网址有错误 > 请检查地址是否完整或存在多余字符")
        ]),
        _c("p", { staticClass: "desc" }, [
          _vm._v("网址已失效 > 可能页面已删除，活动已下线等")
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6dde595f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6dde595f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/error.vue
// module id = ugBg
// module chunks = 235